import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportRecipientModel} from '../reportRecipient.model';
import {Injectable} from '@angular/core';
import {AddressConverter} from '../../../../../common/converter/address.converter';
import {PartnerPersonConverter} from '../../../../../partner/modules/person/api/converter/partnerPerson.converter';
import {
    WorkflowTaskSummaryConverter
} from '../../../../../workflow/task/api/model/common/converter/workflowTaskSummary.converter';
import {DocumentSummaryConverter} from "../../../../../document/common/api/converter/documentSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class ReportRecipientConverter extends HttpModelConverter<ReportRecipientModel> {

    constructor(private workflowTaskSummaryConverter: WorkflowTaskSummaryConverter,
                private partnerPersonConverter: PartnerPersonConverter,
                private documentSummaryConverter: DocumentSummaryConverter,
                private addressConverter: AddressConverter) {
        super();
    }

    protected createInstance(): ReportRecipientModel {
        return new ReportRecipientModel();
    }

    protected enrichObject(result: ReportRecipientModel, src: ReportRecipientModel) {
        result.partnerPerson = this.partnerPersonConverter.convert(src.partnerPerson);
        result.document = this.documentSummaryConverter.convert(src.document);
        result.address = this.addressConverter.convert(src.address);
        result.emailWorkflowTasks = this.workflowTaskSummaryConverter.convertFromArray(src.emailWorkflowTasks);
    }

}
